export default {
  en: {
    contact: {
      getInTouch: 'Get in touch',
      description: 'We are always happy to hear from you! Whether you have a question, feedback, or just want to say hello, feel free to reach out to us. Your input helps us improve and provide the best experience possible.',
      messageCategory: 'Message category',
      general: 'General request',
      meeting: 'Schedule a meeting',
      partner: 'Partnership',
      demo: 'Demo / Trial',
      other: 'Other',
      yourName: 'Your Name',
      nameplaceholder: 'Jane Doe',
      email: 'E-mail',
      emailplaceholder: 'jane[at]mail.com',
      organization: 'Organization (optional)',
      position: 'Position (optional)',
      message: 'Message',
      messagePlaceholder: 'Tell us what concerns you',
      privacyPolicyTextPrefix: 'I accept that my inquiry will be processed according to the',
      privacyPolicyLinkText: 'Privacy Policy',
      send: 'Send',
      clear: 'Clear'
    }
  },
  de: {
    contact: {
      getInTouch: 'Kontakt aufnehmen',
      description: 'Wir freuen uns immer, von Ihnen zu hören! Egal, ob Sie eine Frage haben, Feedback geben möchten oder einfach nur Hallo sagen wollen, zögern Sie nicht, uns zu kontaktieren. Ihr Beitrag hilft uns, uns zu verbessern und das bestmögliche Erlebnis zu bieten.',
      messageCategory: 'Nachrichtenkategorie',
      general: 'Allgemeine Anfrage',
      meeting: 'Termin vereinbaren',
      partner: 'Partnerschaft',
      demo: 'Demo / Testversion',
      other: 'Andere',
      yourName: 'Ihr Name',
      nameplaceholder: 'Jane Doe',
      email: 'E-Mail',
      emailplaceholder: 'jane[at]mail.com',
      organization: 'Organisation (optional)',
      position: 'Position (optional)',
      message: 'Nachricht',
      messagePlaceholder: 'Teilen Sie uns Ihre Anliegen mit',
      privacyPolicyTextPrefix: 'Ich akzeptiere die Verarbeitung gemäß der',
      privacyPolicyLinkText: 'Datenschutzerklärung',
      send: 'Senden',
      clear: 'Zurücksetzen'
    }
  },
  es: {
    contact: {
      getInTouch: 'Ponte en contacto',
      description: '¡Siempre estamos encantados de saber de ti! Ya sea que tengas una pregunta, comentarios o simplemente quieras saludar, no dudes en contactarnos. Tu contribución nos ayuda a mejorar y ofrecer la mejor experiencia posible.',
      messageCategory: 'Categoría de mensaje',
      general: 'Consulta general',
      meeting: 'Programar una reunión',
      partner: 'Asociación',
      demo: 'Demostración / Prueba',
      other: 'Otro',
      yourName: 'Tu nombre',
      nameplaceholder: 'Jane Doe',
      email: 'Correo electrónico',
      emailplaceholder: 'jane[at]mail.com',
      organization: 'Organización (opcional)',
      position: 'Posición (opcional)',
      message: 'Mensaje',
      messagePlaceholder: 'Cuéntanos tus inquietudes',
      privacyPolicyTextPrefix: 'Acepto que mi consulta sea procesada de acuerdo con la',
      privacyPolicyLinkText: 'Política de privacidad',
      send: 'Enviar',
      clear: 'Borrar'
    }
  },
  uk: {
    contact: {
      getInTouch: 'Зв’язатися',
      description: 'Ми завжди раді почути вас! Якщо у вас є питання, відгук або просто хочете привітатися, не соромтеся звертатися до нас. Ваші відгуки допомагають нам покращуватися та надавати найкращий досвід.',
      messageCategory: 'Категорія повідомлення',
      general: 'Загальний запит',
      meeting: 'Запланувати зустріч',
      partner: 'Партнерство',
      demo: 'Демо / Пробна версія',
      other: 'Інше',
      yourName: 'Ваше ім’я',
      nameplaceholder: 'Jane Doe',
      email: 'Електронна пошта',
      emailplaceholder: 'jane[at]mail.com',
      organization: 'Організація (необов’язково)',
      position: 'Посада (необов’язково)',
      message: 'Повідомлення',
      messagePlaceholder: 'Розкажіть нам про ваші проблеми',
      privacyPolicyTextPrefix: 'Я приймаю, що моє звернення буде оброблено відповідно до',
      privacyPolicyLinkText: 'Політики конфіденційності',
      send: 'Надіслати',
      clear: 'Очистити'
    }
  }
}
